var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g({staticClass:"cell-todo-row-item button-clear",class:{
		'cell-todo-row-more': _vm.data.type == 'non',
		'cell-todo-row--un-shadow': !_vm.shadow
	},style:(_setup.insetCalendarColorVar(_vm.data.calendarThemeColor))},_vm.$listeners),[(_vm.data.type == 'non')?[_c('div',{staticClass:"cell-todo-row-value"},[_vm._v(_vm._s(_setup.translateText(_vm.data.value)))]),_c(_setup.SvgIcons,{attrs:{"name":"right-light"}})]:_c('div',{staticClass:"cell-todo-row-value text-overflow"},[_vm._v(_vm._s(_setup.formatScheduleRow))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }